<svg [attr.width]="size()" [attr.height]="height()" viewBox="0 0 44 47" aria-hidden="true">
  <path fill="var(--icon-fill)"
    d="M15.65 1.608a12 12 0 0 1 12 0l9.651 5.571a12 12 0 0 1 6 10.393v11.143a12 12 0 0 1-6 10.393l-9.65 5.572a12 12 0 0 1-12 0L6 39.107a12 12 0 0 1-6-10.393V17.572A12 12 0 0 1 6 7.179l9.65-5.571Z" />

  <path fill="none" stroke="var(--icon-stroke)"
    d="M15.9 2.041a11.5 11.5 0 0 1 11.5 0l9.651 5.571a11.5 11.5 0 0 1 5.75 9.96v11.144a11.5 11.5 0 0 1-5.75 9.959l-9.65 5.571a11.5 11.5 0 0 1-11.5 0l-9.65-5.571a11.5 11.5 0 0 1-5.75-9.96V17.572a11.5 11.5 0 0 1 5.75-9.959l9.65-5.57Z" />

  <foreignObject y="1" width="44" height="44">
    <div class="w-full h-full flex items-center justify-center">
      <ng-content></ng-content>
    </div>
  </foreignObject>
</svg>
